<template>
    <div>
      <div class="box-margin">
        <Card>
          <Form
            :model="formItem"
            :label-width="100"
            label-position="left"
            :disabled="prevent"
          >
            <Row style="margin-bottom: 0">
              <Col span="5" >
                <FormItem label="员工工号">
                  <Input v-model="formItem.empcode"></Input>
                </FormItem>
              </Col>
              <Col span="5" offset="2">
                <FormItem label="员工姓名">
                  <Input v-model="formItem.userName"></Input>
                </FormItem>
              </Col>
              <Col span="1" offset="1">
                <Button type="primary" @click="getUserInfo"><!-- 检索 -->{{$t('Search')}}</Button>
              </Col>
            </Row>
          </Form>
        </Card>
        <Table
          border
          :columns="columns1"
          :no-data-text="$t('noData')"
          :data="data1"
          :loading="modal_loading"
        >
          <template slot-scope="{ row }" slot="action">
            <Button type="primary" @click="applyDetail(row)"
              >查看详情</Button
            >
          </template>
        </Table>
        <Page style="display: flex;justify-content: flex-end;margin-top: 20px;" :current="pageInfo1.pageNo" :total="pageInfo1.itemCount" @on-change="pageChange1" />
      </div>
    </div>
  </template>
  <script>
  import DateUtil from "../../../util/DateUtil";
  import ModelUtils from "../../../util/ModelUtil";
  import axios from "axios";
  export default {
    data() {
      return {
        formItem: {},
        pageInfo1: {
                  itemCount: 0,
                  pageNo: 1,
                  pageSize: 10,
              },
        filter: {},
        pageInfo: {
          itemCount: 0,
          pageNo: 1,
          pageSize: 10,
        },
        mxPageInfo: {
          itemCount: 0,
          pageNo: 1,
          pageSize: 10,
        },
        totalNum: 0,
        prevent: false,
        modal_loading: false,
        config: false,
        selRow: {},
        titleText: this.$t('share.selectPeople'),
        applyText: this.$t('leavePaid.applicationDetails'),
        applyVisiable: false,
        date: new DateUtil(),
        columns1: [
          {
            title: "员工工号",
            key: "empcode",
            align: "center",
          },
          {
            title: "姓名",
            key: "userName",
            align: "center",
          },
          {
            title:"公司",
            key: "org1cname",
            align: "center",
          },
          {
            title:"地区",
            key: "org2cname",
            align: "center",
          },
          {
            title: "操作",
            slot: "action",
            width: 150,
            align: "center",
            fixed: "right",
          },
        ],
        data1: [],
        rsztList: []
      };
    },
    watch: {},
    mounted() {
      this.getUserInfo()
    },
    updated(){
    //   this.empty();
    },
    methods: {
     
      getUserInfo() {
          this.modal_loading=true
        let arr = {
            pageNo : this.pageInfo1.pageNo,
            pageSize : this.pageInfo1.pageSize,
            userName : this.formItem.userName,
            empcode : this.formItem.empcode,
            dirFlg:'1'
        }
        axios.post("/EPayslip/selectEPayslip", arr).then((res) => {
           this.data1 = res.data
           this.modal_loading=false
           this.pageInfo1.itemCount= parseInt(res.pageInfo.total)  
        });
      },
      
      applyDetail(row){
        this.$router.push("/9DDDD207C9A4ACFC1FC6BD2C843BAABC/A3FFBEBFDB713E27?serialnumber="+row.serialnumber+"&is_report=true");
      },
      pageChange1(i) {
              this.pageInfo1.pageNo = i
              this.getUserInfo()
          },
      //清空表单
      
     
        }
  };
  </script>
  <style  scoped>
  .box-margin {
    margin-bottom: 20px;
  }
  </style>


// WEBPACK FOOTER //
// src/components/process/MyQuery/EmployeeEpayLip.vue